export interface GridItemType {
    index: number;
    item?: DragItemType;
    isHinted: boolean;
    row: number;
    col: number;
    size: number;
    x: number;
    y: number;
}


export enum DragEvents {
    "OVER" = "OVER",
    "END" = "END",
}

export type DragEventsType = keyof typeof DragEvents;

export type ItemType = "GHOST" | "VISIBLE";

export type GridType = GridItemType[][];

export interface DragItemType {
    id: string;
    typeOfItem: TypeOfItem;
    type: ItemType;
    items: number[];
    isDisappearance: boolean;
    width: number;
    bombMovesLeft?: number;
    indexToolPanel?: number;
}

export type TypeOfItemsMiniAngles = "MINI_ANGLE_LEFT_TOP" | "MINI_ANGLE_RIGHT_TOP" | "MINI_ANGLE_RIGHT_BOTTOM" | "MINI_ANGLE_LEFT_BOTTOM";
export type TypeOfItemsAngles = "ANGLE_LEFT_TOP" | 'ANGLE_LEFT_BOTTOM' | 'ANGLE_RIGHT_BOTTOM' | 'ANGLE_RIGHT_TOP';
export type TypeOfItemsCol = "DOUBLE_COL" | "TRIPLE_COL" | "FOUR_COL" | "FIVE_COL";
export type TypeOfItemsRow = "DOUBLE_ROW" | "TRIPLE_ROW" | "FOUR_ROW" | "FIVE_ROW";
export type TypeOfItemsSquare = "DOUBLE_SQUARE" | "TRIPLE_SQUARE";

export const COLUMN_ITEMS: TypeOfItemsCol[] = ['DOUBLE_COL', 'TRIPLE_COL', 'FOUR_COL', "FIVE_COL"];
export const ROW_ITEMS: TypeOfItemsRow[] = ['DOUBLE_ROW', "TRIPLE_ROW", "FOUR_ROW", "FIVE_ROW"];
export const SQUARE_ITEMS: TypeOfItemsSquare[] = ['DOUBLE_SQUARE', 'TRIPLE_SQUARE'];
export const MINI_ANGLES_ITEMS: TypeOfItemsMiniAngles[] = [
    'MINI_ANGLE_LEFT_TOP', "MINI_ANGLE_RIGHT_TOP", "MINI_ANGLE_RIGHT_BOTTOM", 'MINI_ANGLE_LEFT_BOTTOM'
];
export const ANGLES_ITEMS: TypeOfItemsAngles[] = ['ANGLE_LEFT_TOP', 'ANGLE_LEFT_BOTTOM', 'ANGLE_RIGHT_BOTTOM', 'ANGLE_RIGHT_TOP'];

export type TypeOfItem = "BOMB" | "SINGLE" | TypeOfItemsCol | TypeOfItemsRow | TypeOfItemsSquare | TypeOfItemsMiniAngles | TypeOfItemsAngles;

